import {FlusiaIcon} from '../ui/FlusiaIcon';
import {useFluPilot} from '../../lib/onboarding/consultant/useFluPilot';

/** Contextual entry when a mobile record drawer covers the global header. */
export function FluRecordTrigger({containerClassName}:{containerClassName?:string}){
 const pilot=useFluPilot();
 if(!pilot)return null;
 const trigger=<button type="button" className="flu-header-trigger flu-record-trigger shrink-0" aria-label="Flù, assistente AI" title="Parla con Flù" onClick={()=>window.dispatchEvent(new Event('flusia:flu-open'))}><FlusiaIcon name="flu" size={20}/></button>;
 return containerClassName?<div className={containerClassName}>{trigger}</div>:trigger;
}
